import { register } from '@shopify/theme-sections';
import Swiper from 'swiper/bundle';

register('collection-list', {
  onLoad() {
    this.cleanSlide(this.id);
  },

  cleanSlide(id) {
    const target = `.collection-list--${id}`;
    new Swiper(target, {
      slidesPerView: 3,
      freeMode: true,
      breakpoints: {
        300: {
          slidesPerView: 1.3,
          centeredSlides: true,
          centeredSlidesBounds: true,
        },
        660: {
          slidesPerView: 2.3,
          centeredSlides: false,
        },
        960: {
          slidesPerView: 3,
          centeredSlides: false,
        },
      },
    });
  },
});
